import * as React from "react";
import { SocialNetworksId } from "@/interfaces";
import { SocialMentionData } from "@/services/bedrock/dtos/Post";

import { SearchControls } from "./components/SearchControls";
import { SearchResults } from "./components/SearchResults";
import { AppliedMentions } from "./components/AppliedMentions";
import { SearchProvider } from "./SearchContext";

export interface AbstractPlayer {
  userId: number;
  playerId: number;
  name: string | null;
  photoUrl?: string | null;
}

interface Props {
  players?: AbstractPlayer[];
  mentions: SocialMentionData[];
  networksFilter?: SocialNetworksId[];
  onAddMention: (mention: SocialMentionData) => void;
  onRemoveMention: (mention: SocialMentionData) => void;
  isPosted?: boolean;
}

export function SocialMentionSearch({
  players = [],
  mentions,
  networksFilter,
  onAddMention,
  onRemoveMention,
  isPosted,
}: Props) {
  return (
    <SearchProvider
      players={players}
      mentions={mentions}
      onAddMention={onAddMention}
      onRemoveMention={onRemoveMention}
      networksFilter={networksFilter?.map(sn => (sn === "IG_STORY" ? "IG" : sn))}
      isPosted={isPosted}
    >
      <div className={`flex flex-col gap-8`}>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <SearchControls />
          <SearchResults />
        </div>

        <AppliedMentions mentions={mentions} isPosted={isPosted} onRemoveMention={onRemoveMention} />
      </div>
    </SearchProvider>
  );
}
